import { cn } from '@/shadcn-ui/utils';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { colors } from '@/theme/colors';

export default function Facebook({
  className,
  fillPrimary = colors.neutral60,
  fillSecondary = colors.neutral100,
  hoverFillPrimary = 'group-hover:fill-flexcar-neutral1',
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('group h-[16px] w-[16px]', className)}
    >
      <g clipPath="url(#clip0_5877_3343)">
        <path
          d="M8 0C3.58176 0 0 3.58176 0 8C0 11.7517 2.58304 14.8998 6.06752 15.7645V10.4448H4.41792V8H6.06752V6.94656C6.06752 4.22368 7.29984 2.9616 9.97312 2.9616C10.48 2.9616 11.3546 3.06112 11.7123 3.16032V5.37632C11.5235 5.35648 11.1955 5.34656 10.7882 5.34656C9.47648 5.34656 8.9696 5.84352 8.9696 7.13536V8H11.5827L11.1338 10.4448H8.9696V15.9414C12.9309 15.463 16.0003 12.0902 16.0003 8C16 3.58176 12.4182 0 8 0Z"
          fill={fillPrimary}
          className={hoverFillPrimary}
        />
      </g>
      <defs>
        <clipPath id="clip0_5877_3343">
          <rect width="16" height="16" fill={fillSecondary} />
        </clipPath>
      </defs>
    </svg>
  );
}
